import {
  Injectable,
  PLATFORM_ID,
  Inject,
  makeStateKey,
  TransferState,
} from '@angular/core';
import { isPlatformServer } from '@angular/common';

const API_URL_KEY = makeStateKey<string>('API_URL');
const ENVIRONMENT = makeStateKey<string>('ENVIRONMENT');

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  private _apiUrl: string;
  private _environment: string;

  constructor(
    private transferState: TransferState,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    this.initializeVariables();
  }

  initializeVariables(): void {
    if (isPlatformServer(this.platformId)) {
      // On server side, read from process.env
      // Check if the environment variables are set
      this._apiUrl = process.env['API_URL'];
      this._environment = process.env['ENVIRONMENT'];
      // Store in transfer state
      this.transferState.set(API_URL_KEY, process.env['API_URL']);
      this.transferState.set(ENVIRONMENT, process.env['ENVIRONMENT']);
    } else {
      // On client side, read from transfer state
      this._apiUrl = this.transferState.get(
        API_URL_KEY,
        'https://api-stg.hala.com'
      );
      this._environment = this.transferState.get(ENVIRONMENT, 'staging');
    }
  }

  get apiUrl(): string {
    return this._apiUrl;
  }

  get environment(): string {
    return this._environment;
  }
}
